import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Standard } from "@/types";

export function useStandards() {
  return useQuery({
    queryKey: ["standards"],
    queryFn: () => apiFetch<Standard[]>(`/v1/home/standards`),
    enabled: true, // TODO: remove when API is ready
  });
}
